import { render, staticRenderFns } from "./customerInformationFlowView.vue?vue&type=template&id=52bc7f75&scoped=true"
import script from "./customerInformationFlowView.vue?vue&type=script&lang=js"
export * from "./customerInformationFlowView.vue?vue&type=script&lang=js"
import style0 from "./customerInformationFlowView.vue?vue&type=style&index=0&id=52bc7f75&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bc7f75",
  null
  
)

export default component.exports